export default __webpack_public_path__ + "static/media/other.ba8a38fd.gif";